import { t as translations } from '../../i18n/FeedbackFormTranslation/en-US-DU4VqPXy.js';

function formatMessageHelper(id) {
  return {
    id,
    defaultMessage: translations[id]
  };
}

export { formatMessageHelper as f };
//# sourceMappingURL=formatMessageHelper-CMOV131q.js.map
